import { LayoutGrid, List } from "lucide-react"

import { Button, cn } from "@atlant/ui"

import { useFleetViewStore } from "#pages/authenticated/fleet/components/toolbar/use-fleet-view-store.ts"

export const FleetViewToggle = () => {
  const { view, setView } = useFleetViewStore()

  return (
    <div className="flex overflow-hidden rounded-lg border">
      <Button
        variant="ghost"
        size="icon"
        className={cn(
          "size-8 rounded-none",
          view === "grid" && "bg-accent! text-accent-foreground",
        )}
        onClick={() => setView("grid")}
      >
        <LayoutGrid className="size-4" />
      </Button>
      <Button
        variant="ghost"
        size="icon"
        className={cn(
          "size-8 rounded-none border-l",
          view === "list" && "bg-accent! text-accent-foreground",
        )}
        onClick={() => setView("list")}
      >
        <List className="size-4" />
      </Button>
    </div>
  )
}
